import type {Combinator} from './types';

// @ts-expect-error - TS7006 - Parameter 'callback' implicitly has an 'any' type. | TS7006 - Parameter 'event' implicitly has an 'any' type.
const callIfFunction = (callback, event) =>
  typeof callback === 'function' ? callback(event) : false;

// for interop with callFirstMatch, we want to return true if any of
// the callbacks returns true, so we use reduce instead of forEach
export const callEveryMatch: Combinator =
  (...callbacks) =>
  (event) =>
    // @ts-expect-error - TS2322 - Type 'boolean | Listener | undefined' is not assignable to type 'boolean | undefined'.
    callbacks.reduce(
      (acc, callback) => callIfFunction(callback, event) || acc,
      false
    );

export const callFirstMatch: Combinator =
  (...callbacks) =>
  // @ts-expect-error - TS2322 - Type '(event: Event) => boolean' is not assignable to type 'Listener'.
  (event: Event) =>
    callbacks.some((callback) => callIfFunction(callback, event));
